import { render, staticRenderFns } from "./GiftModalForApi.vue?vue&type=template&id=0bda7f1a&scoped=true&lang=pug&"
import script from "./GiftModalForApi.vue?vue&type=script&lang=js&"
export * from "./GiftModalForApi.vue?vue&type=script&lang=js&"
import style0 from "./GiftModalForApi.vue?vue&type=style&index=0&id=0bda7f1a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bda7f1a",
  null
  
)

export default component.exports